<div class="navigation-items space-y-1 p-3">
  @for (menuItem of navigation()?.default || []; track trackByFn($index, menuItem)) {
    <!-- Basic Navigation Item -->
    @if (menuItem.type === 'basic') {
      <a
        [routerLink]="menuItem.link"
        routerLinkActive="navigation-item-active"
        class="navigation-item hover:bg-surface-container text-on-surface hover:text-on-surface-variant flex items-center rounded-lg px-4 py-3 transition-all duration-200"
      >
        @if (menuItem.icon.includes(':')) {
          <mat-icon
            [svgIcon]="menuItem.icon"
            class="mr-3 text-lg opacity-70 transition-opacity duration-200 group-hover:opacity-100"
          ></mat-icon>
        } @else {
          <mat-icon class="mr-3 text-lg opacity-70 transition-opacity duration-200 group-hover:opacity-100">{{
            menuItem.icon
          }}</mat-icon>
        }
        <span class="font-medium">{{ menuItem.title }}</span>
      </a>
    }

    <!-- Group Navigation Item -->
    @if (menuItem.type === 'group') {
      <div class="group-container">
        <!-- Group Header -->
        <div class="group-header mb-2 px-4 py-2">
          <div class="flex items-center">
            <mat-icon [svgIcon]="menuItem.icon" class="text-primary mr-3 text-sm"></mat-icon>
            <div>
              <div class="text-on-primary-container text-sm font-semibold">{{ menuItem.title }}</div>
              @if (menuItem.subtitle) {
                <div class="text-on-primary-container text-xs opacity-70">{{ menuItem.subtitle }}</div>
              }
            </div>
          </div>
        </div>

        <!-- Group Items -->
        @if (menuItem.children) {
          <div class="group-items ml-2 space-y-1">
            @for (childItem of menuItem.children; track trackByFn($index, childItem)) {
              <!-- Basic Child Item -->
              @if (childItem.type === 'basic') {
                <a
                  [routerLink]="childItem.link"
                  routerLinkActive="navigation-item-active"
                  class="navigation-item hover:bg-surface-container text-on-surface flex items-center rounded-lg px-4 py-2 transition-all duration-200"
                >
                  <mat-icon
                    [svgIcon]="childItem.icon"
                    class="mr-3 text-lg opacity-70 transition-opacity duration-200 group-hover:opacity-100"
                  ></mat-icon>
                  <span class="font-medium">{{ childItem.title }}</span>
                </a>
              }

              <!-- Collapsible Child Item -->
              @if (childItem.type === 'collapsable') {
                <div class="collapsible-item">
                  <!-- Collapsible Header -->
                  <button
                    (click)="toggleCollapsible(childItem.id)"
                    class="collapsible-header text-on-primary-container group flex w-full items-center justify-between rounded-lg px-4 py-2 transition-all duration-200"
                    matRipple
                  >
                    <div class="flex items-center">
                      <mat-icon
                        [svgIcon]="childItem.icon"
                        class="mr-3 transition-opacity duration-200 group-hover:opacity-100"
                      ></mat-icon>
                      <span class="font-medium">{{ childItem.title }}</span>
                    </div>
                    <mat-icon
                      class="expand-icon transition-transform duration-200"
                      [class.rotate-180]="isExpanded(childItem.id)"
                      svgIcon="heroicons_outline:chevron-down"
                    ></mat-icon>
                  </button>

                  <!-- Collapsible Content -->
                  @if (isExpanded(childItem.id)) {
                    <div class="collapsible-content animate-slide-down mt-1 ml-6 space-y-1">
                      @if (childItem.children) {
                        @for (subItem of childItem.children; track trackByFn($index, subItem)) {
                          <a
                            [routerLink]="subItem.link"
                            routerLinkActive="navigation-item-active"
                            class="navigation-item hover:bg-surface-container text-on-surface flex items-center rounded-lg px-4 py-2 transition-all duration-200"
                          >
                            @if (subItem.icon) {
                              <mat-icon
                                [svgIcon]="subItem.icon"
                                class="mr-3 text-lg opacity-70 transition-opacity duration-200 group-hover:opacity-100"
                              ></mat-icon>
                            } @else {
                              <div class="mr-3 flex w-6 justify-center">
                                <div class="bg-on-surface-variant h-1 w-1 rounded-full opacity-50"></div>
                              </div>
                            }
                            <span class="font-medium">{{ subItem.title }}</span>
                          </a>
                        }
                      }
                    </div>
                  }
                </div>
              }
            }
          </div>
        }
      </div>
    }
  }
</div>
